/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_1_DescInputs */

const en_landing_how_1_desc = /** @type {(inputs: Landing_How_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answer questions written for your idea, in rounds. Bystep writes the PRD, features and a layered backlog.`)
};

const id_landing_how_1_desc = /** @type {(inputs: Landing_How_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jawab pertanyaan yang disusun untuk idemu, bertahap. Bystep menulis PRD, fitur, dan backlog berlapis.`)
};

/**
* | output |
* | --- |
* | "Answer questions written for your idea, in rounds. Bystep writes the PRD, features and a layered backlog." |
*
* @param {Landing_How_1_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const landing_how_1_desc = /** @type {((inputs?: Landing_How_1_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_1_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_landing_how_1_desc(inputs)
	return en_landing_how_1_desc(inputs)
});